import { skipToken } from "@tanstack/react-query";
import { useListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet } from "vl-api/vlComponents";
import { CustomMetadataField } from "vl-api/vlSchemas";

export interface UseCustomMetadataProps {
  datasetId: string;
  enabled?: boolean;
}

export const useCustomMetadata = ({
  datasetId,
  enabled = true,
}: UseCustomMetadataProps) => {
  const { data: customMetadataData } =
    useListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet(
      enabled && datasetId ? { pathParams: { datasetId } } : skipToken,
      {
        // Cache the data for 1 hour to prevent repeated fetches
        staleTime: 1000 * 60 * 60, // 1 hour
        refetchOnWindowFocus: false,
      },
    );

  return {
    data: customMetadataData as CustomMetadataField[] | null,
  };
};
